module.exports = __webpack_public_path__ + "static/media/pkd.37a66977.jpg";